import React, { useState, useRef } from 'react'
import Link from 'next/link'
import classnames from 'classnames'

import { sendTeaCommEvent } from 'lib/tea-analyze'

import MyImage from 'Components/image'
import PreloadImage from 'Components/preload-image'
import { useIntervalAnimation } from 'Components/hooks'
import { IAdData, IBannerAD } from '../ad/interface'
import { VideoImage, VideoTitle } from '../ad/banner'
export interface IBanner {
  open_url: string
  cover: string
  title: string
  gid: string
  column_name: string
}

interface IProps {
  banner: IBanner[]
  bannerAd: IAdData[]
}

export default function Banner({ banner, bannerAd }: IProps) {
  /* 当前选中的图片 */
  if (banner == null || banner.length === 0) return <></>
  const [index, setIndex] = useState(0)
  const dom = useRef<HTMLDivElement>(null)
  const bannerWithAd = React.useMemo<(IBanner | IBannerAD)[]>(() => {
    const newBanner: (IBanner | IBannerAD)[] = [...banner]
    // 广告加载中
    if (bannerAd == null) {
      return banner
    }
    bannerAd.map(item => {
      // 替换改成插入，非广告数据后移
      newBanner.splice(item.index - 1, 0, item.raw_spread_data)
      return item
    })
    return newBanner.filter(item => !!item).slice(0, 7)
  }, [bannerAd, banner])

  useIntervalAnimation({
    start: index,
    max: bannerWithAd.length - 1,
    ref: dom,
    callback(current) {
      setIndex(current)
      if ((bannerWithAd[current] as IBannerAD).materiel_str) return
      sendTeaCommEvent('show_video_banner', {
        group_id: banner[current].gid,
        rank: current,
        material_url: banner[current].cover,
      })
    },
    interval: 5000,
  })

  /* 渲染左边的图片 */
  function renderPhoto() {
    let img = ''
    if ((bannerWithAd[index] as IBannerAD).materiel_str) {
      img = (bannerWithAd[index] as IBannerAD).image.url
    } else {
      img = `${(bannerWithAd[index] as IBanner).cover.replace(
        'large',
        'origin'
      )}.jpg`
    }
    return (
      <div className="fl photo">
        <MyImage transition={false} src={img} className="image" />
        {(bannerWithAd[index] as IBannerAD).materiel_str ? (
          <VideoImage data={bannerWithAd[index] as IBannerAD} />
        ) : (
          <Link
            href={`/article?gid=${banner[index] ? banner[index].gid : ''}`}
            as={`/article/${banner[index] ? banner[index].gid : ''}`}
          >
            <a
              target="_blank"
              className="container"
              onClick={() => {
                sendTeaCommEvent('click_video_banner', {
                  group_id: banner[index].gid,
                  rank: index,
                  material_url: banner[index].cover,
                })
              }}
            >
              <div className="text">
                <h4>{banner[index].column_name}</h4>
                <h3>{banner[index].title}</h3>
              </div>
            </a>
          </Link>
        )}
        <style jsx>
          {`
            .container {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
            }
            .photo {
              position: relative;
              width: 750px;
              min-width: 750px;
              height: 420px;
              min-height: 420px;
              overflow: hidden;
            }
            .photo :global(.image) {
              width: 100%;
              transition: background 0.2s ease-in-out;
            }
            .text {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              padding: 30px 23px;
              font-weight: 500;
              color: #fff;
              background-image: linear-gradient(
                to bottom,
                rgba(0, 0, 0, 0),
                rgba(0, 0, 0, 0.5)
              );
            }
            h3 {
              margin-top: 8px;
              line-height: 42px;
              font-size: 30px;
            }
            h4 {
              line-height: 33px;
              font-size: 24px;
            }
          `}
        </style>
      </div>
    )
  }

  /* 渲染右边的标题 */
  function renderTitleList() {
    // 模糊背景图
    let img = ''
    if ((bannerWithAd[index] as IBannerAD).materiel_str) {
      img = (bannerWithAd[index] as IBannerAD).image.url
    } else {
      img = `${(bannerWithAd[index] as IBanner).cover.replace(
        'large',
        'origin'
      )}.jpg`
    }
    return (
      <div className="whole fl">
        <MyImage transition={false} src={img} className="image" />
        <ul>
          {bannerWithAd
            .slice(0, 7)
            .map((item: IBanner | IBannerAD, num: number) => {
              // 广告
              if ((item as IBannerAD).materiel_str) {
                return (
                  <li
                    className={classnames(
                      {
                        active: index === num,
                      },
                      'line-1'
                    )}
                    onMouseEnter={() => {
                      setIndex(num)
                    }}
                  >
                    <VideoTitle result={item as IBannerAD} />
                  </li>
                )
              }
              // 运营位
              const iBanner = item as IBanner
              return (
                <Link
                  key={item.title}
                  href={`/article?gid=${iBanner.gid}`}
                  as={`/article/${iBanner.gid}`}
                >
                  <a target="_blank">
                    <li
                      className={classnames(
                        {
                          active: index === num,
                        },
                        'line-1'
                      )}
                      onMouseEnter={() => {
                        setIndex(num)
                      }}
                    >
                      {iBanner.title}
                    </li>
                  </a>
                </Link>
              )
            })}
        </ul>
        <style jsx>
          {`
            .whole {
              position: relative;
              overflow: hidden;
              width: 440px;
              height: 420px;
            }
            .whole :gloabl(.image) {
              height: 100%;
              background-repeat: no-repeat;
              background-size: 750px 100%;
              background-position: -160px 0;
              background-blend-mode: multiply;
              filter: blur(27px);
            }
            ul {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              padding: 14px 20px 0 20px;
              font-size: 18px;
              color: #fff;
              background: #1a1a1a;
            }
            .line-1 {
              color: #ffffff;
            }
            @supports (filter: blur(27px)) {
              .image {
                filter: none;
              }
              ul {
                background-color: rgba(51, 51, 51, 0.6) !important;
              }
            }
            li {
              position: relative;
              margin: 26px 0;
              line-height: 25px;
              white-space: nowrap;
            }
            .active {
              padding-left: 10px;
              font-size: 24px;
              font-weight: 500;
              cursor: pointer;
              background: rbga(0, 0, 0, 0.1);
              transition: all 0.2s ease-in-out;
            }
            .active::before {
              content: '';
              position: absolute;
              width: 6px;
              height: 24px;
              top: 0;
              left: -2px;
              margin-right: 5px;
              vertical-align: middle;
              background-color: #ffe100;
            }
          `}
        </style>
      </div>
    )
  }
  const images = React.useMemo(() => {
    return bannerWithAd.map(i => {
      const url = (i as IBanner).cover
        ? `${(i as IBanner).cover.replace('large', 'origin')}.jpg`
        : (i as IBannerAD).image.url.replace('large', 'origin')
      return url
    })
  }, [bannerWithAd])
  return (
    <section className="clearfix" ref={dom}>
      {renderPhoto()}
      {renderTitleList()}
      {/* 预加载页面防止切换图片时闪烁的问题 */}
      <PreloadImage urls={images} />
      <style jsx>
        {`
          div {
            margin-top: 10px;
          }
        `}
      </style>
    </section>
  )
}
